import { render, staticRenderFns } from "./sliderLaptopBig.vue?vue&type=template&id=35e954c6&scoped=true&"
import script from "./sliderLaptopBig.vue?vue&type=script&lang=js&"
export * from "./sliderLaptopBig.vue?vue&type=script&lang=js&"
import style0 from "./sliderLaptopBig.vue?vue&type=style&index=0&id=35e954c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e954c6",
  null
  
)

export default component.exports